import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AppService, GRSSUserRoles } from 'src/app/_services/app.service';

@Component({
    selector: 'app-monitor-markets',
    templateUrl: './monitor-markets.component.html',
    styleUrls: ['./monitor-markets.component.css'],
    standalone: false
})
export class MonitorMarketsComponent implements OnInit, OnDestroy {


  displayColumns: string[] = ['markets', 'timeToOpen', 'timeToClose', 'timeToPublish', 'quorum', 'status'];
  dataSource;
  marketsLength = 0;
  intervals: any[] = [];

  staffRoleName: string = GRSSUserRoles.Staff;
  isLoading: boolean = false;

  constructor(@Inject('BASE_URL') private baseUrl: string, private http: HttpClient, public service: AppService, private dialog: MatDialog) {
    this.service.SetTranslation('administration/monitor-markets');
   }

  ngOnInit() {
    this.GetMarkets();
  }

  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** Gets the markets details from server */
  GetMarkets() {
    this.isLoading = true;
    this.http.get<MonitorMarket[]>(this.baseUrl + 'api/monitorMarkets').subscribe(result => {
      this.marketsLength = result.length;
      this.dataSource = new MatTableDataSource(result);
      this.dataSource = result;
      if (this.marketsLength > 0) {
       result.forEach(o => {
          const interval = setInterval(() => {
            //  const o = result[2];
            this.http.get<SummaryRecord>(this.baseUrl + 'api/monitorMarkets/getSummaryRecord/' + o.marketId).subscribe(res => {
              o.contributors = res.contributors;
              o.timeToOpen = res.timeToOpen;
              o.timeToClose = res.timeToClose;
              o.timeToPublish = res.timeToPublish;

              switch (res.statusIcon) {
                case 'Good': {
                  o.statusIcon = 'check';
                  o.statusColor = 'text-success';
                  break;
                }
                case 'Error': {
                  o.statusIcon = 'clear';
                  o.statusColor = 'text-danger';
                  break;
                }
                case 'Waiting': {
                  o.statusIcon = 'watch_later';
                  o.statusColor = 'text-primary';
                  break;
                }
                case 'Tasks': {
                  o.statusIcon = 'task';
                  o.statusColor = 'text-info';
                  break;
                }
                case 'Excel': {
                  o.statusIcon = 'insert_chart';
                  o.statusColor = 'text-info';
                  break;
                }
                case 'Calculating': {
                  o.statusIcon = 'calculate';
                  o.statusColor = 'text-info';
                  break;
                }
                case 'Calculated': {
                  o.statusIcon = 'insert_chart_outlined' ;
                  o.statusColor = 'text-info';
                  break;
                }
                case 'Paused': {
                  o.statusIcon = 'pause';
                  o.statusColor = 'text-secondary';
                  break;
                }
              }
              o.status = res.statusName;
            }, error => {
              console.error(error);
            });
          }, 1000);
          this.intervals.push(interval);
        });
      }
    }, error => {
      console.error(error);
    }, () => {
      this.isLoading = false;
    });
  }

  /**
   * Click event of a market
   * @param element selected market
   */
  OnClickMarket(element: MonitorMarket) {
    if (this.service.currentUser.userRole !== GRSSUserRoles.Staff) {
      window.open(this.baseUrl + 'monitors/markets/monitor?ID=' + element.marketId, '', 'width=1200,height=700,resizable=yes');
      // window.open(this.baseUrl + 'admin/monitors/markets/monitor?ID=' + element.marketId, '_blank');
    }

    // const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = true;
    // dialogConfig.autoFocus = true;
    // dialogConfig.width = '60%';
    // dialogConfig.position = { top: '5%' };
    // dialogConfig.data = element;
    // this.dialog.open(MonitorComponent, dialogConfig).afterClosed().subscribe();
  }
}

/** An interface to access market details */
interface MonitorMarket {
  marketId: string;
  code: string;
  description: string;
  quorum: number;
  contributors: number;
  contributionStart: string;
  contributionFinish: string;
  timeToPublish: string;
  timeToOpen: string;
  timeToClose: string;
  status: string;
  statusIcon: string;
  statusColor: string;
  comments: string;
}

/** An interface to map results from server */
interface SummaryRecord {
  timeToOpen: string;
  timeToClose: string;
  timeToPublish: string;
  statusName: string;
  statusIcon: string;
  contributors: number;
}
